module.exports = __webpack_public_path__ + "img/miradore.f49d72d2.svg";